/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Status_Template_EmbeddingInputs */



/**
* | output |
* | --- |
* | "Document processing" |
*
* @param {Partner_Status_Template_EmbeddingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_status_template_embedding = /** @type {((inputs?: Partner_Status_Template_EmbeddingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Status_Template_EmbeddingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumentenverarbeitung")
	return /** @type {LocalizedString} */ ("Document processing")
});